export const tags = [
  "jnct-lti-config-modal",
  "lti-sync-setup",
  "lti-sync-manager",
  "lti-sync-process",
  "lti-sync-students",
  "lti-sync-confirm",
  "lti-sync-assignments",
] as const;
